import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProjects: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconProjects"><Path d="M19.8574 21H4.14062L1.82422 10H22.1738L19.8574 21Z" fill="currentColor"/><Path d="M19.999 8H3.99902V6.5H19.999V8Z" fill="currentColor"/><Path d="M17.999 4.5H5.99902V3H17.999V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProjects;
